import { ObjectField } from "./ObjectField";
export class TaskTypeField {
    Id: number | string | null;
    Tenant: number;
    ObjectFieldCode: string | null;
    Mandatory: boolean;
    ObjectField: ObjectField | null;
}
